








































































import { bitrateFormatter, bytesToSize } from '@tt4b/ttam-utils';
import { defineComponent, PropType } from '@vue/composition-api';
import VideoPlayer from '@/components/common/video-player/index.vue';
import AuthorizeRightPic from '@tt4b/ttam-assets/src/images/creative/authorization-right.png';
import PlusPic from '@tt4b/ttam-assets/src/images/creative/tt-preview-plus.png';
import AuthorizeBottomPic from '@tt4b/ttam-assets/src/images/creative/authorization-bottom.png';
import AuthorizeTopPic from '@tt4b/ttam-assets/src/images/creative/authorization-top.png';
import AuthorizeShop from '@tt4b/ttam-assets/src/images/creative/authorization-shop.png';
import { PreviewVideoInfo } from '../types';

const name = 'ttam-identity-tiktok-post-authorize-preview';

export default defineComponent({
  name,
  components: { VideoPlayer },
  props: {
    videoInfo: {
      type: Object as PropType<PreviewVideoInfo>,
      default: () => ({}),
    },
  },
  setup() {
    const formatDuration = (time: number) => {
      const intTime = Math.round(time);
      const minute = intTime / 60 > 1 ? `${parseInt(`${intTime / 60}`, 10)} min ` : '';
      const second = `${intTime % 60} s`;

      return `${minute}${second}`;
    };

    return {
      name,
      PlusPic,
      AuthorizeShop,
      AuthorizeTopPic,
      AuthorizeBottomPic,
      AuthorizeRightPic,
      bytesToSize,
      formatDuration,
      bitrateFormatter,
    };
  },
});
